export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  parcels: {
    all: ['parcels'] as const,
    my: (params?: object) => ['parcels', 'my', params ?? {}] as const,
    detail: (id: string) => ['parcels', 'detail', id] as const,
    charges: (id: string) => ['parcels', 'charges', id] as const,
    products: (parcelId: string) => ['parcels', parcelId, 'products'] as const,
    availableForPhotoVideo: (type: string) =>
      ['parcels', 'available-for-photo-video', type] as const,
    availableForSplit: ['parcels', 'available-for-split'] as const,
    availableForReturn: ['parcels', 'available-for-return'] as const,
    myDebts: ['parcels', 'my', 'debts'] as const,
  },
  receipts: {
    all: ['receipts'] as const,
    my: ['receipts', 'my'] as const,
    public: (id: string) => ['receipts', 'public', id] as const,
  },
  splits: {
    all: ['splits'] as const,
    list: (params?: object) => ['splits', 'list', params ?? {}] as const,
    byParcel: (parcelId: string) => ['splits', 'list', { parcel: parcelId }] as const,
    detail: (id: string) => ['splits', 'detail', id] as const,
  },
  userPackages: {
    all: ['user-packages'] as const,
    list: (page: number) => ['user-packages', 'list', page] as const,
    detail: (id: string) => ['user-packages', 'detail', id] as const,
  },
  cargoIds: {
    all: ['cargo-ids'] as const,
  },
  categories: {
    all: ['categories'] as const,
  },
  pinfl: {
    all: ['pinfl'] as const,
    detail: (pinfl: string, excludeParcel?: string) =>
      excludeParcel
        ? (['pinfl', pinfl, excludeParcel] as const)
        : (['pinfl', pinfl] as const),
  },
  pricing: {
    config: ['pricing', 'config'] as const,
  },
  reports: {
    all: ['reports'] as const,
  },
  returns: {
    all: ['returns'] as const,
  },
  addresses: {
    all: ['addresses'] as const,
    detail: (id: string) => ['addresses', 'detail', id] as const,
  },
  support: {
    faqs: ['support', 'faqs'] as const,
    chat: ['support', 'chat'] as const,
  },
  supportStaff: {
    all: ['support-staff'] as const,
  },
  notifications: {
    all: ['notifications'] as const,
    list: (page?: number, lang?: string) =>
      ['notifications', 'list', page ?? 1, lang ?? 'uz'] as const,
    unreadCount: ['notifications', 'unread-count'] as const,
  },
  tracking: {
    all: ['tracking'] as const,
    lookup: (trekId: string) => ['tracking', 'lookup', trekId] as const,
    saved: ['tracking', 'saved'] as const,
  },
} as const;
